module.exports = "/packs/media/images/icons/grades-67a247a1ca7c06348942e8fd0a778892.png";